import { Component, OnInit, Output, EventEmitter, Input, ViewChild } from '@angular/core';
import { TYPEMODULE, LoaderService, NotificationService, ICONS, ACTIONS, EVENTO, TOOLTIPS, GridDataSource } from '../../../../shared/session/index';
import { RolService } from '../shared/rol.service';
import { SectionBarComponent } from 'src/app/shared/sectionbar/sectionbar.component';

@Component({
  selector: 'app-rol-list',
  templateUrl: 'rol-list.component.html',
})

export class RolListComponent implements OnInit {
  @Output() onChangeEvent: EventEmitter<any> = new EventEmitter();
  @ViewChild(SectionBarComponent) sectionBarComponent: SectionBarComponent;
  @Input() typeModule: TYPEMODULE;
  @Input() titlePage: string;
  @Input() data: any;

  displayedColumns: string[] = ['User', 'Access', 'Autonomia', 'RolID', 'Name', 'Descripcion', 'ShortName', 'Status'];
  dataSource: GridDataSource;
  msgErrorGet: string;
  selectedRowIndex: number = -1;
  buttonGroup: any;
  showMessageGridEmpty: boolean = false;

  constructor(
    private loaderService: LoaderService,
    private rolService: RolService,
    private notificationService: NotificationService,
  ) { }

  ngOnInit() {
    this.msgErrorGet = 'Error al listar rol';
    this.buttonGroup = [
      { tooltip: TOOLTIPS.new, icon: ICONS.new, action: ACTIONS.new }
    ];
  }

  handleRowClick(row: any, event: any) {
    if (event.srcElement.cellIndex) {
      if (event.srcElement.cellIndex != 0) {
        this.selectedRowIndex = row.ID;
        this.data.rol = { ID: row.ID, Name: row.Name };
        this.changeEvent({ evento: EVENTO.consultar, data: this.data });
      }
    }
  }

  accessRowClick(cell: any) {
    this.selectedRowIndex = cell.ID;
    this.data.rol = { ID: cell.ID, Name: cell.Name };
    this.changeEvent({ evento: EVENTO.accesoSubmodulo, data: this.data });
  }

  userRowClick(cell: any) {
    this.selectedRowIndex = cell.ID;
    this.data.rol = { ID: cell.ID, Name: cell.Name };
    this.changeEvent({ evento: EVENTO.accesoUsuario, data: this.data });
  }

  autonomiaRowClick(cell: any) {
    this.selectedRowIndex = cell.ID;
    this.data.rol = { ID: cell.ID, Name: cell.Name };
    this.changeEvent({ evento: EVENTO.asignarAutonomia, data: this.data });
  }

  searchEmit(data: any) {
    this.buscarRol(data.filtro);
  }

  changeEvent(event) {
    this.onChangeEvent.emit(event);
  }

  onNew() {
    this.changeEvent({ evento: EVENTO.crear, data: {} });
  }

  buscarRol(filtro: string) {
    this.listarRol(filtro);
  }

  fabButtonEmit(action: any) {
    switch (action) {
      case ACTIONS.new:
        this.onNew();
        break;
      default:
        break;
    }
  }

  listarRol(filtro: string,): void {
    this.loaderService.show();
    this.rolService.listarPorRol(filtro)
      .subscribe(res => {
        this.dataSource = new GridDataSource(res);
        this.showHideMessageGridEmpty(Number(res.length));
      },
        error => {
          this.notificationService.error(this.msgErrorGet);
          throw error;
        },
        () => {
          this.loaderService.hide();
        });
  }

  showHideMessageGridEmpty(rows: number) {
    this.showMessageGridEmpty = false;
    if (rows <= 0) this.showMessageGridEmpty = true;
  }
}

